import { combineReducers, createStore } from 'redux';

const initialState = {
  src: null,
  isOpen: false
};
  
  // actions.js *****************************************************
  export const showPreview = (src) => (
    {
      type: 'SHOW_PREVIEW',
      src: src,
      isOpen: true
    }
  );
  
  export const closePreview = () => (
    {
      type: 'CLOSE_PREVIEW'
    }
  );
  
  // reducers.js *****************************************************
  export const preview = (state = initialState, action) => {
    switch (action.type) {
      case 'SHOW_PREVIEW':
        return {
          src: action.src,
          isOpen: true
        };
      case 'CLOSE_PREVIEW':
        return initialState;
      default:
        return state;
    }
  };
  
  export const reducers = combineReducers({
    preview,
  });
  
  // store.js *****************************************************
  export function configureStore() {
    const store = createStore(reducers, initialState);
    return store;
  };
  
  export const store = configureStore();